import { RecurringProfileInterface } from 'client/Interfaces/RecurringProfileInterface'

import * as api from './apiHelper'

const mySubscription = 'my-subscription'
const availablePlans = 'plans'
const quota = 'my-quota'
const payment = `${mySubscription}/card`
const cancel = `${mySubscription}/cancel`
const coupons = 'coupons'
const settings = 'settings'
const discountCoupons = 'coupons/apply'

const subscriptionEndPoint = (path: string) => `/subscription/${path}`

export const getAvailablePlans = () => {
  return api.Get(subscriptionEndPoint(availablePlans))
}

export const getSubscription = () => {
  return api.Get(subscriptionEndPoint(mySubscription))
}
export const postSubscriptionDiscount = () => {
  return api.Post(subscriptionEndPoint(discountCoupons))
}
export const getInvoices = () => {
  return api.Get(subscriptionEndPoint(`${mySubscription}/invoices`))
}

export const postSubscription = (
  planId: string,
  sourceId: string,
  paymentType: string,
  invoiceEmail: string,
  captchaToken: string,
  captchaAction: string,
  couponCode?: string,
  isNotVATLiable?: boolean,
) => {
  return api.Post(subscriptionEndPoint(mySubscription), {
    planId,
    sourceId,
    paymentType,
    invoiceEmail,
    captchaToken,
    captchaAction,
    couponCode,
    isNotVATLiable,
  })
}

export const putSubscription = (planId: string, isNotVATLiable: boolean, couponCode?: string) => {
  return api.Put(subscriptionEndPoint(mySubscription), { planId, isNotVATLiable, couponCode })
}

export const continueCurrentPlan = () => {
  return api.Put(subscriptionEndPoint(`${mySubscription}/continue-current-plan`))
}

export const getQuota = () => {
  return api.Get(subscriptionEndPoint(quota))
}

export const getSubscriptionSettings = () => {
  return api.Get(subscriptionEndPoint(settings))
}
interface SubscriptionSettingsUpdate {
  settingsItem: string
  settingsValue: boolean | string | number
}

export async function postSubscriptionSettingsChanges(
  data: SubscriptionSettingsUpdate,
): Promise<RecurringProfileInterface> {
  return (await api.Post(subscriptionEndPoint(settings), data)) as Promise<RecurringProfileInterface>
}

export const putPaymentSource = (
  sourceId: string,
  paymentType: string,
  captchaToken: string,
  captchaAction: string,
) => {
  return api.Put(subscriptionEndPoint(payment), { sourceId, paymentType, captchaToken, captchaAction })
}

export const postPayInvoices = () => {
  return api.Post(subscriptionEndPoint(`${mySubscription}/pay-unpaid`))
}

export const cancelSubscription = () => {
  return api.Put(subscriptionEndPoint(cancel))
}

export const getCoupon = (couponCode: string, planName?: string) => {
  return api.Get(`${subscriptionEndPoint(coupons)}/${couponCode}`, true, { plan: planName })
}

export const updateSubscriptionPrice = (isNotVATLiable) => {
  return api.Put(`${subscriptionEndPoint(mySubscription)}/update-price`, { isNotVATLiable })
}

interface GetUpgradePriceResponse {
  total: number // The total price with VAT
  priceWithoutTax: number // The total price without VAT
  tax: number // The total VAT
  proration: number // The proration WITHOUT VAT
  prorationTax: number // The proration VAT
}

export const getUpgradePrice = (planId: string, isNotVATLiable?: boolean): Promise<GetUpgradePriceResponse> => {
  return api.Post(subscriptionEndPoint(`${mySubscription}/upgrade-price`), {
    planId,
    isNotVATLiable,
  }) as Promise<GetUpgradePriceResponse>
}

export const getStripePublicKeyVersion = () => {
  return api.Get(subscriptionEndPoint(`${mySubscription}/stripe-public-key-version`), true)
}

export const updateAccountingSubscription = () => {
  return api.Post(subscriptionEndPoint(`${mySubscription}/update-accounting-subscription`))
}
